/**
 * External dependencies
 */
import React from "react";
import { Stack } from "@towersystems/towersystems-design-system";
/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import "./styles.scss";

const SettingsGroup = ({ children }) => {
  return (
    <Stack className="settings-group" dividers>
      {children}
    </Stack>
  );
};

export default SettingsGroup;
